<template>
    <el-form :model="formAddress" :rules="rules" ref="formAddress" class="address-system">
        <el-row>
            <el-col :span="12">
                <el-form-item label="จังหวัด" label-width="100px" prop="province">
                    <el-select
                        v-model="formAddress.province"
                        reserve-keyword
                        filterable
                        placeholder="กรุณาเลือกจังหวัด"
                        :loading="loading.province"
                        style="width: 97%;"
                        @focus="fetchProvince('')"
                        @change="
                            fetchProvince(''), selectAddressValue('province')
                        "
                    >
                        <el-option
                            v-for="item in provinceArray"
                            :key="item.provinceId"
                            :label="item.provinceName"
                            :value="item.provinceName"
                            autocomplete="off"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="อำเภอ" label-width="100px" prop="district">
                    <el-select
                        v-model="formAddress.district"
                        filterable
                        placeholder="กรุณาเลือกอำเภอ"
                        :loading="loading.district"
                        :disabled="disabled.district"
                        style="width: 100%;"
                        label-width="200px"
                        @focus="fetchDistrict()"
                        @change="
                            fetchDistrict(), selectAddressValue('district')
                        "
                    >
                        <el-option
                            v-for="item in districtArray"
                            :key="item.districtId"
                            :label="item.districtName"
                            :value="item.districtName"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="ตำบล" label-width="100px" prop="subDistrict">
                    <el-select
                        v-model="formAddress.subDistrict"
                        filterable
                        placeholder="กรุณาเลือกตำบล"
                        :loading="loading.subDistrict"
                        :disabled="disabled.subDistrict"
                        style="width: 97%;"
                        label-width="200px"
                        @focus="fetchSubDistrict()"
                        @change="
                            fetchSubDistrict(),
                                selectAddressValue('subDistrict')
                        "
                    >
                        <el-option
                            v-for="item in subDistrictArray"
                            :key="item.subDistrictId"
                            :label="item.subDistrictName"
                            :value="item.subDistrictName"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="รหัสไปรษณีย์" label-width="100px" prop="zipcode">
                    <el-select
                        v-model="formAddress.zipcode"
                        filterable
                        placeholder="กรุณาเลือกรหัสไปรษณีย์"
                        :loading="loading.zipcode"
                        :disabled="disabled.zipcode"
                        style="width: 98%;"
                        label-width="200px"
                        @focus="fetchZipcode()"
                        @change="fetchZipcode(), selectAddressValue('zipcode')"
                    >
                        <el-option
                            v-for="item in zipcodeArray"
                            :key="item.zipcodeId"
                            :label="item.detail"
                            :value="item.detail"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
</template>
<script>
import fgApi from '@/services/fillgoods'
export default {
    name: 'AddressSystem',
    props: {
        address: {
            type: Object,
            default: null
        },
        isSubmitForm: {
            type: Boolean,
            default: false
        },
        isCancel: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            formAddress: {
                province: '',
                district: '',
                subDistrict: '',
                zipcode: ''
            },
            addressId: {
                province_id: '',
                district_id: '',
                subDistrict_id: ''
            },
            loading: {
                province: false,
                district: false,
                subDistrict: false,
                zipcode: false
            },
            disabled: {
                district: true,
                subDistrict: true,
                zipcode: true
            },
            provinceArray: [],
            districtArray: [],
            subDistrictArray: [],
            zipcodeArray: [],
            rules: {
                province: [
                    { required: true, message: 'กรุณาเลือกจังหวัด', trigger: 'change' }
                ],
                district: [
                    { required: true, message: 'กรุณาเลือกอำเภอ', trigger: 'change' }
                ],
                subDistrict: [
                    { required: true, message: 'กรุณาเลือกตำบล', trigger: 'change' }
                ],
                zipcode: [
                    { required: true, message: 'กรุณาเลือกรหัสไปรษณีย์', trigger: 'change' }
                ]
            }
        }
    },
    watch: {
        isSubmitForm (val) {
            if (val) {
                this.$refs['formAddress'].validate()
            }
        },
        isCancel (val) {
            this.disabled = {
                district: true,
                subDistrict: true,
                zipcode: true
            }
            if (val) {
                this.$emit('onCancel', false)
                this.$refs.formAddress.resetFields()
            }
        },
        'address.province': {
            immediate: true,
            handler (province) {
                this.formAddress.province = province
            }
        },
        'address.district': {
            immediate: true,
            handler (district) {
                this.formAddress.district = district
            }
        },
        'address.subDistrict': {
            immediate: true,
            handler (subDistrict) {
                this.formAddress.subDistrict = subDistrict
            }
        },
        'address.zipcode': {
            immediate: true,
            handler (zipcode) {
                this.formAddress.zipcode = zipcode
            }
        }
    },
    methods: {
        async fetchProvince (province) {
            this.loading.province = true
            this.disabled.district = false
            try {
                let paramProv = {
                    search: province
                }
                let resProv = await fgApi.order.searchProvince(paramProv)
                if (resProv.success) {
                    this.provinceArray = resProv.data.provinces
                    this.provinceArray.sort((a, b) => {
                        return a.provinceId - b.provinceId
                    })
                } else {
                    this.provinceArray = []
                    this.$message.error('Get province not success')
                }
            } catch (error) {
                this.$message.error('Oops, Api is ' + error + '!')
            }
            this.loading.province = false
        },
        async fetchDistrict () {
            this.loading.district = true
            this.disabled.subDistrict = false
            try {
                this.addressId.province_id = this.provinceArray
                    .filter(e => {
                        return e.provinceName === this.formAddress.province
                    })
                    .map(e => {
                        return e.provinceId
                    })[0]
                let paramDist = this.addressId
                let resDist = await fgApi.order.searchDistrict(paramDist)
                if (resDist.success) {
                    this.districtArray = resDist.data.districts
                    this.districtArray.sort((a, b) => {
                        return a.districtId - b.districtId
                    })
                } else {
                    this.districtArray = []
                    this.$message.error('Get district not success')
                }
            } catch (error) {
                this.$message.error('Oops, Api is ' + error + '!')
            }
            this.loading.district = false
        },
        async fetchSubDistrict () {
            this.loading.subDistrict = true
            this.disabled.zipcode = false
            try {
                this.addressId.district_id = this.districtArray
                    .filter(e => {
                        return e.districtName === this.formAddress.district
                    })
                    .map(e => {
                        return e.districtId
                    })[0]
                let paramSubDist = this.addressId
                let resSubDist = await fgApi.order.searchSubDistrict(
                    paramSubDist
                )
                if (resSubDist.success) {
                    this.subDistrictArray = resSubDist.data.subDistricts
                    this.subDistrictArray.sort((a, b) => {
                        return a.subDistrictId - b.subDistrictId
                    })
                } else {
                    this.subDistrictArray = []
                    this.$message.error('Get sub-district not success')
                }
            } catch (error) {
                this.$message.error('Oops, Api is ' + error + '!')
            }
            this.loading.subDistrict = false
        },
        async fetchZipcode () {
            this.loading.zipcode = true
            try {
                this.addressId.subDistrict_id = this.subDistrictArray
                    .filter(e => {
                        return (
                            e.subDistrictName === this.formAddress.subDistrict
                        )
                    })
                    .map(e => {
                        return e.subDistrictId
                    })[0]
                let paramZip = this.addressId
                let resZip = await fgApi.order.searchZipcode(paramZip)
                if (resZip.success) {
                    this.zipcodeArray = resZip.data.zipcode
                    this.zipcodeArray.sort((a, b) => {
                        return a.zipcodeId - b.zipcodeId
                    })
                } else {
                    this.$message.error('Get zipcode not success')
                }
            } catch (error) {
                this.$message.error('Oops, Api is ' + error + '!')
            }
            this.loading.zipcode = false
        },
        selectAddressValue (item) {
            switch (item) {
            case 'province':
                this.address.province = this.formAddress.province
                this.formAddress.zipcode = ''
                this.formAddress.district = ''
                this.formAddress.subDistrict = ''
                this.$emit('updated:address', this.formAddress)
                break
            case 'district':
                this.address.district = this.formAddress.district
                this.formAddress.zipcode = ''
                this.formAddress.subDistrict = ''
                this.$emit('updated:address', this.formAddress)
                break
            case 'subDistrict':
                this.address.subDistrict = this.formAddress.subDistrict
                this.formAddress.zipcode = ''
                this.$emit('updated:address', this.formAddress)
                break
            case 'zipcode':
                this.address.zipcode = this.formAddress.zipcode
                this.$emit('updated:address', this.formAddress)
                break
            default:
                break
            }
        }
    }
}
</script>
<style scoped lang="scss">
.address-system{
    ::v-deep .el-input.is-disabled{
        .el-input__inner{
            color: #000;
        }
    }

}
</style>
